// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BulkSigningModal_jointsList__Eahzz h6 {
  margin-bottom: 1rem;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/CertificateDetails/BulkSigningModal.module.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;EACA,gBAAA;AAAJ","sourcesContent":[".jointsList {\r\n  h6 {\r\n    margin-bottom: 1rem;\r\n    font-weight: 600;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"jointsList": `BulkSigningModal_jointsList__Eahzz`
};
export default ___CSS_LOADER_EXPORT___;
